// @see https://bitbucket.org/flightscope/dto-schema/src/master/baseball/entity/player-substitution.json

import SubstitutionType from "./SubstitutionType.js";

const Substitution = {
    EnteredTagID: { key: 'enteredTagID', name: 'enteredTagID', type: 'NUMBER' },
    ReplacedTagID: { key: 'replacedTagID', name: 'replacedTagID', type: 'NUMBER'  },
    Type: { key: 'type', name: 'type', type: 'STRING', enum: SubstitutionType },
    EnteredDate: { key: 'enteredDate', name: 'enteredDate', type: 'string' },
};

export default Substitution;